import React, { useCallback } from 'react';
import styles from '../AccountSearchAiChat.module.css';

interface ChatInputFieldProps {
  isFetching: boolean;
  fetchResponse: (input: string) => any;
  autofocus: boolean;
}

const ChatInputField: React.FC<ChatInputFieldProps> = ({
  isFetching,
  fetchResponse,
  autofocus,
}) => {
  const [input, setInput] = React.useState('');
  const [disabled, setDisabled] = React.useState(false);

  // We maintain a local disabled state since `isFetching` is updated asynchronously.
  React.useEffect(() => setDisabled(isFetching), [isFetching]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && !e.shiftKey && !disabled) {
        e.preventDefault();
        if (input.trim()) {
          fetchResponse(input.trim());
          setDisabled(true);
          setInput('');
        }
      }
    },
    [fetchResponse, input, setInput, disabled]
  );

  return (
    <div className={styles.userInputField}>
      <input
        className='tw-text-primary'
        value={input}
        placeholder='Ask a follow-up question'
        onChange={e => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={2000}
        autoFocus={autofocus}
      />
    </div>
  );
};

export default ChatInputField;
